// extracted by mini-css-extract-plugin
export default {"cards":"CardsCollection_cards__NVJ1K"};